import { ToothApplianceType, TreatmentApplianceType, TreatmentType } from '../enums';

export function getApplianceTypeName(treatmentApplianceType: TreatmentApplianceType): string {
  let applianceType: string = '';

  switch (treatmentApplianceType) {
    case TreatmentApplianceType.DentureBase:
      applianceType = 'general.base';
      break;
    case TreatmentApplianceType.DentureTeeth:
      applianceType = 'general.teeth';
      break;
    case TreatmentApplianceType.TryInDenture:
      applianceType = 'general.tryIn';
      break;
    case TreatmentApplianceType.HybridDenture:
      applianceType = 'general.hybrid';
      break;
    case TreatmentApplianceType.Crown:
      applianceType = 'general.crown&Bridge';
      break;
    case TreatmentApplianceType.ImplantCrown:
      applianceType = 'general.implantCrown';
      break;
    case TreatmentApplianceType.Retainer:
      applianceType = 'general.retainer';
      break;
    case TreatmentApplianceType.Restorations:
      applianceType = 'general.restorations';
      break;
    default:
      applianceType = TreatmentApplianceType[treatmentApplianceType];
      break;
  }

  return applianceType;
}
export function getApplianceTypeNameV2(
  treatmentApplianceType: TreatmentApplianceType,
  isDistinguishCrown: Boolean = false
): string {
  let applianceType: string = '';

  switch (treatmentApplianceType) {
    case TreatmentApplianceType.OcclusalGuard:
      applianceType = 'general.occlusalGuard';
      break;
    case TreatmentApplianceType.RemovableDieModel:
      applianceType = 'general.dentalModel';
      break;
    case TreatmentApplianceType.SurgicalGuide:
      applianceType = 'general.surgicalGuideAppliance';
      break;
    case TreatmentApplianceType.HybridDenture:
      applianceType = 'general.hybridDenture';
      break;
    case TreatmentApplianceType.Crown:
      if (isDistinguishCrown) {
        applianceType = 'general.posterirCrown';
      } else {
        applianceType = 'general.crown&Bridge';
      }
      break;
    case TreatmentApplianceType.ImplantCrown:
      applianceType = 'general.implantCrown';
      break;
    case TreatmentApplianceType.Veneer:
      applianceType = 'general.veneers';
      break;
    case TreatmentApplianceType.DentureBase:
      applianceType = 'general.dentureBase';
      break;
    case TreatmentApplianceType.DentureTeeth:
      applianceType = 'general.dentureTeeth';
      break;
    case TreatmentApplianceType.TryInDenture:
      applianceType = 'general.tryInDenture';
      break;
    case TreatmentApplianceType.Unset:
      applianceType = 'general.freeFlow';
      break;
    case TreatmentApplianceType.Retainer:
      applianceType = 'general.retainer';
      break;
    case TreatmentApplianceType.AlignerRetainerModel:
      applianceType = 'general.alignerModels';
      break;
    case TreatmentApplianceType.Bridge:
      applianceType = 'general.bridge';
      break;
    case TreatmentApplianceType.InlayAndOnlay:
      applianceType = 'general.inlayOnlay';
      break;
    case TreatmentApplianceType.Scan:
      applianceType = 'general.scan';
      break;
    case TreatmentApplianceType.Restorations:
      applianceType = 'general.restorations';
      break;
    default:
      applianceType = TreatmentApplianceType[treatmentApplianceType];
      break;
  }

  return applianceType;
}

export function getApplianceTypeImageV2(
  applianceType: TreatmentApplianceType,
  isDistinguishCrown: Boolean = false
): string {
  let applianceTypeImage: string = '';

  switch (applianceType) {
    case TreatmentApplianceType.OcclusalGuard:
      applianceTypeImage = 'night-guard.webp';
      break;
    case TreatmentApplianceType.RemovableDieModel:
      applianceTypeImage = 'models-for-aligners.webp';
      break;
    case TreatmentApplianceType.SurgicalGuide:
      applianceTypeImage = 'surgical-guide.webp';
      break;
    case TreatmentApplianceType.HybridDenture:
      applianceTypeImage = 'onx-implant-denture.webp';
      break;
    case TreatmentApplianceType.Crown:
      if (isDistinguishCrown) {
        applianceTypeImage = 'posterior-crown.webp';
      } else {
        applianceTypeImage = 'bridge-and-crown.webp';
      }
      break;
    case TreatmentApplianceType.ImplantCrown:
      applianceTypeImage = 'implant-crown-with-hole.webp';
      break;
    case TreatmentApplianceType.Veneer:
      applianceTypeImage = 'veneer.webp';
      break;
    case TreatmentApplianceType.DentureBase:
      applianceTypeImage = 'denture-base.webp';
      break;
    case TreatmentApplianceType.DentureTeeth:
      applianceTypeImage = 'denture-teeth.webp';
      break;
    case TreatmentApplianceType.TryInDenture:
      applianceTypeImage = 'denture-try-in.webp';
      break;
    case TreatmentApplianceType.Unset:
      applianceTypeImage = 'custom.webp';
      break;
    case TreatmentApplianceType.Retainer:
      applianceTypeImage = 'retainer.webp';
      break;
    case TreatmentApplianceType.AlignerRetainerModel:
      applianceTypeImage = 'aligner-models.webp';
      break;
    case TreatmentApplianceType.Bridge:
      applianceTypeImage = 'bridge.webp';
      break;
    case TreatmentApplianceType.InlayAndOnlay:
      applianceTypeImage = 'inlay-onlay.webp';
      break;
    case TreatmentApplianceType.Scan:
      applianceTypeImage = 'scan.webp';
      break;
    case TreatmentApplianceType.Restorations:
      applianceTypeImage = 'fixed-restorations.webp';
      break;
  }

  return `assets/images/print-job-types/${applianceTypeImage}`;
}

export function getApplianceTypeNameByTreatmentAndApplianceType(
  treatmentType: TreatmentType,
  treatmentApplianceType: TreatmentApplianceType,
  isV2_0: boolean = false
): string {
  let applianceType: string = '';

  switch (treatmentApplianceType) {
    case TreatmentApplianceType.DentureBase:
      if (treatmentType === TreatmentType.RemovableDentures) {
        applianceType = 'general.baseMaterial';
      } else {
        applianceType = 'general.dentureBase';
      }

      break;
    case TreatmentApplianceType.DentureTeeth:
      applianceType = 'general.teethMaterial';
      break;
    case TreatmentApplianceType.TryInDenture:
      applianceType = 'general.tryInMaterial';
      break;
    case TreatmentApplianceType.Crown:
      if (treatmentType === TreatmentType.RemovablePartialDenture) {
        applianceType = 'general.ponticSites';
      } else if (
        treatmentType === TreatmentType.CrownAndBridge ||
        treatmentType === TreatmentType.AICrown ||
        treatmentType === TreatmentType.SingleImplantWithCrown
      ) {
        applianceType = 'general.crown';
      }
      if (treatmentType === TreatmentType.CrownAndBridge && isV2_0) {
        applianceType = 'general.restorations';
      }
      break;
    case TreatmentApplianceType.Bridge:
      if (treatmentType === TreatmentType.CrownAndBridge) {
        applianceType = 'general.bridge';
      }
      break;
    case TreatmentApplianceType.SurgicalGuide:
      applianceType = 'general.surgicalGuideAppliance';
      break;
    case TreatmentApplianceType.RemovableDieModel:
      if (treatmentType === TreatmentType.SmileDesign) {
        applianceType = 'general.waxUpModel';
      } else if (treatmentType === TreatmentType.AICrown) {
        applianceType = 'general.removableDie';
      } else if (treatmentType === TreatmentType.Veneers || treatmentType === TreatmentType.NeerCrystal) {
        applianceType = 'general.dentalModel';
      } else {
        applianceType = 'general.modelAndRemovableDie';
      }
      if (
        (treatmentType === TreatmentType.CrownAndBridge || treatmentType === TreatmentType.ImplantRestorations) &&
        isV2_0
      ) {
        applianceType = 'general.model';
      }
      break;
    case TreatmentApplianceType.SmileDesignSnapOn:
      if (treatmentType === TreatmentType.SmileDesign) {
        applianceType = 'general.trialSmile';
      }
      break;
    case TreatmentApplianceType.Veneer:
      applianceType = 'general.veneers';
      break;
    case TreatmentApplianceType.ImplantCrown:
      if (treatmentType === TreatmentType.ImplantRestorations) {
        applianceType = 'general.restorations';
      }
      break;
    case TreatmentApplianceType.Restorations:
      applianceType = 'general.restorations';
      break;
    default:
      applianceType = '';
      break;
  }

  return applianceType;
}

export function getApplianceTypeNameByTreatmentType(treatmentTypeId: number, treatmentTypeName: string = ''): string {
  let applianceType: string;

  switch (treatmentTypeId) {
    case TreatmentType.SmileDesign:
      applianceType = 'general.dentalModel';
      break;
    case TreatmentType.SurgicalGuide:
      applianceType = 'general.surgicalGuideAppliance';
      break;
    case TreatmentType.RemovableDentures:
      applianceType = 'general.prosthetics';
      break;
    case TreatmentType.Custom:
      applianceType = 'general.otherPrint';
      break;
    case TreatmentType.CrownAndBridge:
    case TreatmentType.ImplantRestorations:
      applianceType = 'general.fixedRestorations';
      break;
    case TreatmentType.AIRetainer:
      applianceType = 'general.retainer';
      break;
    case TreatmentType.ClearAligner:
      applianceType = 'general.alignerModels';
      break;
    default:
      applianceType = treatmentTypeName;
      break;
  }

  return applianceType;
}

export function getApplianceTypeImage(applianceType: TreatmentApplianceType): string {
  let applianceTypeImage: string;

  switch (applianceType) {
    case TreatmentApplianceType.DentureBase:
      applianceTypeImage = 'denture-base.webp';
      break;
    case TreatmentApplianceType.DentureTeeth:
      applianceTypeImage = 'denture-teeth.webp';
      break;
    case TreatmentApplianceType.TryInDenture:
      applianceTypeImage = 'denture-try-in.webp';
      break;
    case TreatmentApplianceType.HybridDenture:
      applianceTypeImage = 'onx-implant-denture.webp';
      break;
    case TreatmentApplianceType.Crown:
      applianceTypeImage = 'bridge-and-crown.webp';
      break;
    case TreatmentApplianceType.Veneer:
      applianceTypeImage = 'veneer.webp';
      break;
    case TreatmentApplianceType.ImplantCrown:
      applianceTypeImage = 'implant-crown-with-hole.webp';
      break;
    case TreatmentApplianceType.Retainer:
      applianceTypeImage = 'retainer.webp';
      break;
    case TreatmentApplianceType.Restorations:
      applianceTypeImage = 'fixed-restorations.webp';
      break;
    default:
      applianceTypeImage = 'custom.webp';
      break;
  }

  return `assets/images/print-job-types/${applianceTypeImage}`;
}

export function getApplianceTypeImageByTreatmentType(treatmentTypeId: number): string {
  let applianceTypeImage: string;

  switch (treatmentTypeId) {
    case TreatmentType.NightGuard:
    case TreatmentType.AINightGuard:
      applianceTypeImage = 'night-guard.webp';
      break;
    case TreatmentType.SmileDesign:
    case TreatmentType.DentalModel:
      applianceTypeImage = 'models-for-aligners.webp';
      break;
    case TreatmentType.SurgicalGuide:
      applianceTypeImage = 'surgical-guide.webp';
      break;
    case TreatmentType.RemovableDentures:
      applianceTypeImage = 'denture-new.webp';
      break;
    case TreatmentType.CrownAndBridge:
    case TreatmentType.ImplantRestorations:
      applianceTypeImage = 'fixed-restorations.webp';
      break;
    case TreatmentType.AIRetainer:
    case TreatmentType.ManualRetainer:
      applianceTypeImage = 'retainer.webp';
      break;
    case TreatmentType.ClearAligner:
      applianceTypeImage = 'aligner-models.webp';
      break;
    default:
      applianceTypeImage = 'custom.webp';
      break;
  }

  return `assets/images/print-job-types/${applianceTypeImage}`;
}

export function getApplianceTypeByTreatmentType(treatmentType: TreatmentType): TreatmentApplianceType | null {
  switch (treatmentType) {
    case TreatmentType.AINightGuard:
    case TreatmentType.NightGuard:
      return TreatmentApplianceType.OcclusalGuard;
    case TreatmentType.DentalModel:
      return TreatmentApplianceType.RemovableDieModel;
    case TreatmentType.AIRetainer:
    case TreatmentType.ManualRetainer:
      return TreatmentApplianceType.Retainer;
    case TreatmentType.SurgicalGuide:
      return TreatmentApplianceType.SurgicalGuide;
    default:
      return null;
  }
}

export function getToothApplianceTypeName(toothApplianceType: ToothApplianceType): string {
  let applianceType: string;

  switch (toothApplianceType) {
    case ToothApplianceType.PonticSites:
      applianceType = 'general.ponticSites';
      break;
    case ToothApplianceType.Clasps:
      applianceType = 'general.clasps';
      break;
    default:
      applianceType = '';
      break;
  }

  return applianceType;
}

export function getApplianceTypeAbbreviation(applianceType: TreatmentApplianceType): string {
  switch (applianceType) {
    case TreatmentApplianceType.Unset:
      return 'OT';
    case TreatmentApplianceType.RemovableDieModel:
      return 'DM';
    case TreatmentApplianceType.OcclusalGuard:
      return 'OG';
    case TreatmentApplianceType.SurgicalGuide:
      return 'SG';
    case TreatmentApplianceType.TryInDenture:
      return 'DI';
    case TreatmentApplianceType.DentureBase:
      return 'DB';
    case TreatmentApplianceType.HybridDenture:
      return 'DH';
    case TreatmentApplianceType.DentureTeeth:
      return 'DT';
    case TreatmentApplianceType.Crown:
      return 'CB';
    case TreatmentApplianceType.Veneer:
      return 'VN';
    case TreatmentApplianceType.ImplantCrown:
      return 'IC';
    case TreatmentApplianceType.Retainer:
      return 'RT';
    case TreatmentApplianceType.Restorations:
      return 'RS';
    default:
      return '';
  }
}
